var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmShapes2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 94,
    viewBox: "0 0 343 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.4723,
    y: 121.339,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 64.4723 121.339)",
    fill: "#F5C000",
    stroke: "#3913D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7656,
    y: 124.048,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 63.7656 124.048)",
    fill: "#F5C000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 102.773,
    y: 133.308,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 102.773 133.308)",
    fill: "#38CB89",
    stroke: "#3913D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.066,
    y: 136.017,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 102.066 136.017)",
    fill: "#38CB89"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8082,
    y: 126.125,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 77.8082 126.125)",
    stroke: "#3913D2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.1016,
    y: 128.835,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 77.1016 128.835)",
    fill: "#4E5D78"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116.109,
    y: 138.094,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 116.109 138.094)",
    stroke: "#3913D2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115.402,
    y: 140.804,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 115.402 140.804)",
    fill: "#4E5D78"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 231.596,
    y: 81.1152,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 231.596 81.1152)",
    stroke: "#3913D2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 230.89,
    y: 83.8248,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 230.89 83.8248)",
    fill: "#00F58F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 269.901,
    y: 93.0842,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 269.901 93.0842)",
    stroke: "#3913D2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 269.194,
    y: 95.7941,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 269.194 95.7941)",
    fill: "#4E5D78"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -5.29334,
    y: 150.115,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 -5.29334 150.115)",
    stroke: "#3913D2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: 152.825,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 -6 152.825)",
    fill: "url(#paint0_linear_1712_3082)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0094,
    y: 162.085,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 33.0094 162.085)",
    stroke: "#3913D2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3027,
    y: 164.795,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 32.3027 164.795)",
    fill: "url(#paint1_linear_1712_3082)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 207.316,
    y: 118.733,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 207.316 118.733)",
    fill: "white",
    stroke: "#FFAB00"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 206.609,
    y: 135.465,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 206.609 135.465)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 245.618,
    y: 130.702,
    width: 118.008,
    height: 157.061,
    transform: "rotate(-42.952 245.618 130.702)",
    fill: "white",
    stroke: "#FFAB00"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 244.911,
    y: 133.411,
    width: 119.008,
    height: 158.061,
    transform: "rotate(-42.952 244.911 133.411)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1712_3082",
    x1: -6,
    y1: 152.825,
    x2: 126.308,
    y2: 164.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3913D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1712_3082",
    x1: 32.3027,
    y1: 164.795,
    x2: 164.611,
    y2: 176.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3913D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5CFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmShapes2);
export default __webpack_public_path__ + "static/media/crmShapes2.a7c478c5.svg";
export { ForwardRef as ReactComponent };